import React from 'react'
import styled from 'styled-components/macro'

const GeneralButton = styled.button`
  border: 0;
  background: none;
  border-radius: 4px;
  padding: 12px 16px;
  white-space: nowrap;

  font-family: 'Pluto Sans', sans-serif;
  color: ${(props) => props.theme.colors.grey.white};
  font-size: ${(props) => (props.caption ? '12px' : '16px')};
  line-height: ${(props) => (props.caption ? '16px' : '24px')};
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    filter: brightness(110%);
    cursor: pointer;
  }

  &:focus {
    outline: 0;
  }

  @media only screen and (min-width: 768px) {
    padding: 12px 24px;
  }

  /* ie11 */
  @media only screen and (-ms-high-contrast: active) and (-ms-high-contrast: none) {
    min-width: 100px;
  }
`

const Primary = styled(GeneralButton)`
  background-color: ${(props) =>
    props.error
      ? props.theme.colors.grey.grey3
      : props.theme.colors.brand.primary};
  color: ${(props) =>
    props.error
      ? props.theme.colors.grey.grey5
      : props.theme.colors.grey.white};
  width: ${(props) => (props.showOnMobile ? '100%' : 'auto')};
  max-height: ${(props) => (props.constantHeight ? '48px' : 'none')};

  @media only screen and (min-width: 768px) {
    width: auto;
  }
`

const Confirmation = styled(GeneralButton)`
  background-color: ${(props) => props.theme.colors.brand.secondary};
  color: ${(props) => props.theme.colors.grey.white};
  width: auto;
`

const Outline = styled(GeneralButton)`
  background-color: none;
  color: ${(props) => props.theme.colors.brand.primary};
  border: 1px solid ${(props) => props.theme.colors.brand.primary};
`

const Icon = styled.img`
  width: ${(props) => (props.smallIcon ? '12px' : '20px')};

  @media only screen and (min-width: 768px) {
    width: ${(props) => (props.smallIcon ? '16px' : '20px')};
  }

  /* IE11 */
  @media only screen and (-ms-high-contrast: active) and (-ms-high-contrast: none) {
    width: 20px;
  }
`

const TitleWrapper = styled.span`
  display: ${(props) => (props.showOnMobile ? 'inline' : 'none')};
  margin-right: 8px;

  @media only screen and (min-width: 768px) {
    display: inline;
  }
`

const Button = ({
  onClick,
  title,
  type,
  icon,
  error,
  showOnMobile,
  smallIcon,
  caption,
  constantHeight
}) => {
  switch (type) {
    case 'outline':
      return (
        <Outline onClick={error ? undefined : onClick} error={error}>
          <TitleWrapper icon={icon ? 1 : 0} showOnMobile>
            {title}
          </TitleWrapper>
          {icon && <Icon src={icon} alt={title} />}
        </Outline>
      )
    case 'confirmation':
      return (
        <Confirmation onClick={error ? undefined : onClick}>
          {icon ? (
            <>
              <TitleWrapper showOnMobile={showOnMobile}>{title}</TitleWrapper>{' '}
              <Icon src={icon} alt={title} smallIcon={smallIcon} />
            </>
          ) : (
            title
          )}
        </Confirmation>
      )
    default:
      return (
        <Primary
          showOnMobile={showOnMobile}
          onClick={error ? undefined : onClick}
          error={error}
          caption={caption}
          constantHeight={constantHeight}
        >
          {icon ? (
            <>
              <TitleWrapper showOnMobile={showOnMobile}>{title}</TitleWrapper>{' '}
              <Icon src={icon} alt={title} smallIcon={smallIcon} />
            </>
          ) : (
            title
          )}
        </Primary>
      )
  }
}

export default Button
